export default {
  PERIOD: 'period',
  HOURS: 'hours',
};
